<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h6 class="card-title">Logs</h6>
                    <div id="content">
                        <ul class="timeline" >
                            <div *ngFor='let event of atividadesLogs;let i = index'>
                                <li class="event" data-date="*" style="margin-bottom: 15px; padding: 5px;">
                                    <h3>{{ event.dataCriacaoFormat }} - {{ event.tipoAtividadeNome }}</h3>
                                    <div *ngIf="event.tipoStatusAtividadeAnteriorNome && event.tipoStatusAtividadeAnteriorNome != event.tipoStatusAtividadeAtualNome" ><strong>Status anterior:</strong> {{ event.tipoStatusAtividadeAnteriorNome}}.</div>
                                    <div><strong>Status atual:</strong> {{ event.tipoStatusAtividadeAtualNome}}.</div>
                                    <div><strong>Usuário:</strong> {{ event.usuarioCriacaoNome}}.</div>
                                    <div><strong>Data:</strong> {{ event.dataCriacaoFormat}}.</div>                                    
                                    <div *ngIf="event.descricao != undefined"><strong>Descrição:</strong> {{ event.descricao }} </div>
                                    <div *ngIf="event.descricao == undefined && event.tipoStatusAtividadeAnteriorNome != event.tipoStatusAtividadeAtualNome"><strong>Descrição:</strong> Alteração de status </div>
                                </li>
                            </div>
                                                        
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>